import { render, staticRenderFns } from "./PermissionsSettings.vue?vue&type=template&id=13fde6fe"
import script from "./PermissionsSettings.vue?vue&type=script&lang=js"
export * from "./PermissionsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports